import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { NotificationsSelectors, NotificationsDispatchers } from '../../../store';

import { environment } from '../../../../environments/environment';
import { PlanerGodkendt } from '@store/models';
import { LegacyService } from 'app/legacy/legacy.service';

@Component({
    selector: 'app-planer-godkendt',
    template: `
        <app-planer-godkendt-ui
            [planerGodkendt]="planerGodkendt$ | async"
            (gotoKundeEval)="gotoKundeEval($event)"
            (updateSeen)="updateSeen($event)"
            (dismiss)="dismiss()"
        ></app-planer-godkendt-ui>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PlanerGodkendtContainer implements OnInit {
    planerGodkendt$ = this.notificationsSelectors.planerGodkendt$;

    constructor(
        public activeModal: NgbActiveModal,
        private notificationsSelectors: NotificationsSelectors,
        private notificationsDispatchers: NotificationsDispatchers,
        private legacyService: LegacyService
    ) {}

    ngOnInit() {
        this.notificationsDispatchers.loadPlanerGodkendt();
    }

    gotoKundeEval(client: PlanerGodkendt) {
        this.notificationsDispatchers.navigateToClient(client.kid);
        const url = `${environment.legacyUrl}/kundeeval/kundeeval.asp?ID=${client.kid}`;
        const windowParams = `scrollbars,resizable, width=1000,height=800,top=100, left=200`;
        this.legacyService.navigate(url, 'hoponpop', windowParams);
        this.activeModal.close();
    }

    updateSeen(kid: number) {
        this.notificationsDispatchers.updatePlanerGodkendt(kid);
    }

    dismiss() {
        this.activeModal.dismiss();
    }

}
